export const customTranslations = {
  prd: {
    'e1a275a2-83c6-415f-b077-2f8ac1e00aa3': {
      resources: {
        dashboard: {
          title: 'テラシテSサービス管理ページ',
          menu: {
            admin: {
              accounts: 'アカウント管理',
              mappings: '店舗管理'
            },
            highManager: {
              cognitoLog: 'ログインログ取得',
              weeklyData: '週次実績取得'
            },
            spot: '店舗単位表示',
            compare: '店舗間比較表示',
            spotData: '店舗データ出力',
            summary: '分析データ出力'
          },
          notification: {
            cannotUse: 'ご利用できません'
          }
        },
        accounts: {
          fields: {
            name: '氏名',
            email: 'メールアドレス',
            group: '役割',
            managedBy: '管理者',
            area: 'リージョン',
            office: '営業所'
          },
          buttons: {
            create: '新規登録',
            upload: '一括登録・更新',
            download: '登録情報の取得'
          },
          dialogs: {
            create: {
              title: 'アカウント新規登録'
            },
            edit: {
              title: 'アカウント編集'
            },
            mutate: {
              buttons: {
                cancel: 'キャンセル',
                done: '登録'
              }
            },
            selectManager: {
              title: '利用者の管理者の選択'
            }
          },
          groups: {
            admin: 'システム管理者',
            highManager: '上位管理者',
            manager: '管理者',
            user: '利用者'
          }
        },
        mappings: {
          fields: {
            name: '店舗名',
            spin: '地点番号',
            code: '店番',
            managedBy: '担当者',
            'managedBy.name': '氏名',
            'managedBy.email': 'メールアドレス',
            'managedBy.helperText': 'クリックして選択',
            'managedBy.helperTextEdit': 'クリックして変更'
          },
          dialogs: {
            edit: {
              title: '店舗登録編集'
            },
            mutate: {
              buttons: {
                cancel: 'キャンセル',
                done: '登録'
              }
            },
            selectAccount: {
              title: '担当者の選択',
              buttons: {
                cancel: 'キャンセル'
              }
            }
          },
          download: {
            dialog: {
              content:
                '登録済の店舗の一覧をダウンロードします。\n\nダウンロードしたファイルを編集し、一括更新が可能です。',
              buttons: {
                cancel: 'キャンセル',
                confirm: 'ダウンロード'
              }
            },
            notification: {
              downloading: 'ダウンロード中...',
              downloadError: 'ダウンロードできません。',
              noAccounts: '担当者に設定できるアカウントが登録されていません。'
            }
          },
          upload: {
            dialog: {
              content:
                '必ず取得した登録済みの店舗の一覧のファイルを編集した\nファイルのアップロードを行ってください。\n\n',
              buttons: {
                cancel: 'キャンセル',
                confirm: 'アップロード'
              }
            }
          }
        },
        spots: {
          tabs: {
            daily: '日単位',
            monthly: '月単位',
            yearly: '年単位'
          },
          daily: {
            compareTo: {
              lastWeek: '前週同曜日',
              lastYearWithMonthlyAverage: '前年同月平均',
              lastYearWithYearlyAverage: '前年年間平均'
            }
          },
          monthly: {
            compareTo: {
              lastYear: '前年同月',
              lastMonth: '前月',
              lastYearWithMonthlyAverage: '前年同月平均'
            }
          },
          yearly: {
            compareTo: {
              lastYear: '前年度'
            }
          },
          fields: {
            date: '対象日'
          }
        },
        spotData: {
          fields: {
            base: 'ファイル名',
            threshold: '前日比較差の閾値'
          },
          buttons: {
            pdf: 'PDFダウンロード',
            data: 'データダウンロード'
          },
          caution:
            '＜注意＞\n既にデフォルト値として以下の内容が入力されております。\n※デフォルト値から変更してダウンロードされる場合は、ダウンロードに一定の時間を要します。\n【時間単位/日】\n比較元：前週（前週の日～土曜日）　比較対象：前週比　比較差の閾値：1.5\n※比較差の閾値に1.5を入力すると比較対象から150%以上の電気使用量になった時間帯を色付けいたします。\n【日単位/月】\n比較元：出力する日が属する月　比較対象：前年比　目標値の設定値：97.7％\n【月単位/年】\n出力する日の属する年度　比較対象：前年度'
        },
        spotData2: {
          selected: '選択した店舗',
          fields: {
            base: 'ファイル名',
            daily: {
              title: '時間単位/日',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '比較差の閾値'
            },
            monthly: {
              title: '日単位/月',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '目標値の設定値(%)'
            },
            yearly: {
              title: '月単位/年',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '比較差の閾値'
            }
          }
        },
        spotSelect: {
          dialog: {
            title: '店舗の選択'
          },
          buttons: {
            trigger: '店舗の選択',
            all: 'すべて選択',
            clear: '選択解除',
            close: '閉じる'
          }
        },
        spotList: {
          buttons: {
            all: 'すべて選択',
            clear: '選択解除'
          }
        },
        compare: {
          selected: '選択した店舗',
          buttons: {
            target: '対象月',
            input: '対象データの設定',
            close: '閉じる',
            set: '設定',
            execute: '実行',
            compare: '比較グラフ表示'
          },
          show: {
            0: '比較元',
            1: '比較先'
          },
          fileSelect: 'ファイルを選択してください',
          fields: {
            sourceKey: {
              label: '集計に使用する項目名',
              helperText:
                '比較用データとして設定するデータが何のデータか入力ください。\n（例：売上、来店数、延床面積など）'
            },
            targetKey: {
              label: '照合する項目名',
              helperText:
                '電力量のデータにおいて、照合に使用する各店舗の項目の名称を選択してください'
            },
            dateKey: {
              label: '照合する月の形式',
              helperText:
                '指定されたCSVファイルにおいて、照合に使用する月の項目の表示形式を選択してください'
            },
            categories: {
              label: 'グラフの分類項目の設定',
              labels: {
                '0': '左下のエリア',
                '1': '右下のエリア',
                '2': '左上のエリア',
                '3': '右上のエリア'
              }
            }
          }
        },
        allData: {
          fields: {
            all: 'すべての店舗'
          },
          buttons: {
            download: 'データダウンロード',
            clear: '対象店舗の選択解除'
          }
        },
        announce: {
          title: 'サービスからのお知らせ'
        },
        summarys: {
          fields: {
            name: '店舗',
            daily: '時間単位/日',
            monthly: '日単位/月',
            yearly: '月単位/年',
            'daily.date': '比較元',
            'daily.compareTo': '比較対象',
            'monthly.date': '比較元',
            'monthly.compareTo': '比較対象',
            'yearly.date': '比較元',
            'yearly.compareTo': '比較対象'
          }
        },
        mergedUsers: {
          fields: {
            name: '店舗名',
            spin: '供給/受電地点特定番号',
            kind: '契約種別',
            address: '住所'
          }
        },
        footer: {
          text: '© Chubu Electric Power Miraiz Connect, Inc. All rights reserved'
        }
      }
    },
    'fd4b63fd-5ae9-4003-b9e3-3a9605125876': {
      resources: {
        dashboard: {
          title: 'テラシテSサービス管理ページ',
          menu: {
            admin: {
              accounts: 'アカウント管理',
              mappings: '店舗管理'
            },
            highManager: {
              cognitoLog: 'ログインログ取得'
            },
            spot: '店舗単位表示',
            compare: '店舗間比較表示',
            spotData: '店舗データ出力',
            summary: '分析データ出力'
          },
          notification: {
            cannotUse: 'ご利用できません'
          }
        },
        mappings: {
          fields: {
            name: '店舗名',
            spin: '地点番号',
            code: '店舗コード',
            managedBy: '担当者',
            'managedBy.name': '氏名',
            'managedBy.email': 'メールアドレス',
            'managedBy.helperText': 'クリックして選択',
            'managedBy.helperTextEdit': 'クリックして変更'
          },
          dialogs: {
            edit: {
              title: '店舗登録編集'
            },
            mutate: {
              buttons: {
                cancel: 'キャンセル',
                done: '登録'
              }
            },
            selectAccount: {
              title: '担当者の選択',
              buttons: {
                cancel: 'キャンセル'
              }
            }
          },
          download: {
            dialog: {
              content:
                '登録済みの店舗の一覧をダウンロードします。\n\nダウンロードしたファイルを編集し、一括更新が可能です。',
              buttons: {
                cancel: 'キャンセル',
                confirm: 'ダウンロード'
              }
            },
            notification: {
              downloading: 'ダウンロード中...',
              downloadError: 'ダウンロードできません。',
              noAccounts: '担当者に設定できるアカウントが登録されていません。'
            }
          },
          upload: {
            dialog: {
              content:
                '必ず取得した登録済みの店舗の一覧のファイルを編集した\nファイルのアップロードを行ってください。\n\n',
              buttons: {
                cancel: 'キャンセル',
                confirm: 'アップロード'
              }
            }
          }
        },
        spots: {
          tabs: {
            daily: '日単位',
            monthly: '月単位',
            yearly: '年単位'
          },
          daily: {
            compareTo: {
              lastWeek: '前週同曜日',
              lastYearWithMonthlyAverage: '前年同月平均',
              lastYearWithYearlyAverage: '前年年間平均'
            }
          },
          monthly: {
            compareTo: {
              lastYear: '前年同月',
              lastMonth: '前月',
              lastYearWithMonthlyAverage: '前年同月平均'
            }
          },
          yearly: {
            compareTo: {
              lastYear: '前年度'
            }
          },
          fields: {
            date: '対象日'
          }
        },
        spotData: {
          fields: {
            base: 'ファイル名',
            threshold: '前日比較差の閾値'
          },
          buttons: {
            pdf: 'PDFダウンロード',
            data: 'データダウンロード'
          },
          caution:
            '＜注意＞\n既にデフォルト値として以下の内容が入力されております。\n※デフォルト値から変更してダウンロードされる場合は、ダウンロードに一定の時間を要します。\n【時間単位/日】\n比較元：前週（前週の日～土曜日）　比較対象：前週比　比較差の閾値：1.5\n※比較差の閾値に1.5を入力すると比較対象から150%以上の電気使用量になった時間帯を色付けいたします。\n【日単位/月】\n比較元：出力する日が属する月　比較対象：前年比　目標値の設定値：97.7％\n【月単位/年】\n出力する日の属する年度　比較対象：前年度'
        },
        spotData2: {
          selected: '選択した店舗',
          fields: {
            base: 'ファイル名',
            daily: {
              title: '時間単位/日',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '比較差の閾値'
            },
            monthly: {
              title: '日単位/月',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '目標値の設定値(%)'
            },
            yearly: {
              title: '月単位/年',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '比較差の閾値'
            }
          }
        },
        spotSelect: {
          dialog: {
            title: '店舗の選択'
          },
          buttons: {
            trigger: '店舗の選択',
            all: 'すべて選択',
            clear: '選択解除',
            close: '閉じる'
          }
        },
        spotList: {
          buttons: {
            all: 'すべて選択',
            clear: '選択解除'
          }
        },
        compare: {
          selected: '選択した店舗',
          buttons: {
            target: '対象月',
            input: '対象データの設定',
            close: '閉じる',
            set: '設定',
            execute: '実行',
            compare: '比較グラフ表示'
          },
          show: {
            0: '比較元',
            1: '比較先'
          },
          fileSelect: 'ファイルを選択してください',
          fields: {
            sourceKey: {
              label: '集計に使用する項目名',
              helperText:
                '比較用データとして設定するデータが何のデータか入力ください。\n（例：売上、来店数、延床面積など）'
            },
            targetKey: {
              label: '照合する項目名',
              helperText:
                '電力量のデータにおいて、照合に使用する各店舗の項目の名称を選択してください'
            },
            dateKey: {
              label: '照合する月の形式',
              helperText:
                '指定されたCSVファイルにおいて、照合に使用する月の項目の表示形式を選択してください'
            },
            categories: {
              label: 'グラフの分類項目の設定',
              labels: {
                '0': '左下のエリア',
                '1': '右下のエリア',
                '2': '左上のエリア',
                '3': '右上のエリア'
              }
            }
          }
        },
        allData: {
          fields: {
            all: 'すべての店舗'
          },
          buttons: {
            download: 'データダウンロード',
            clear: '対象店舗の選択解除'
          }
        },
        announce: {
          title: 'サービスからのお知らせ'
        },
        summarys: {
          fields: {
            name: '店舗',
            daily: '時間単位/日',
            monthly: '日単位/月',
            yearly: '月単位/年',
            'daily.date': '比較元',
            'daily.compareTo': '比較対象',
            'monthly.date': '比較元',
            'monthly.compareTo': '比較対象',
            'yearly.date': '比較元',
            'yearly.compareTo': '比較対象'
          }
        },
        mergedUsers: {
          fields: {
            name: '店舗名',
            spin: '供給/受電地点特定番号',
            kind: '契約種別',
            address: '住所'
          }
        },
        footer: {
          text: '© Chubu Electric Power Miraiz Connect, Inc. All rights reserved'
        }
      }
    }
  },
  stg: {
    'fdeb2ae0-47d1-4d41-bd0c-7ffdab7f4598': {
      resources: {
        dashboard: {
          title: 'テラシテSサービス管理ページ',
          menu: {
            admin: {
              accounts: 'アカウント管理',
              mappings: '店舗管理'
            },
            highManager: {
              cognitoLog: 'ログインログ取得'
            },
            spot: '店舗単位表示',
            compare: '店舗間比較表示',
            spotData: '店舗データ出力',
            summary: '分析データ出力'
          },
          notification: {
            cannotUse: 'ご利用できません'
          }
        },
        accounts: {
          fields: {
            name: '氏名',
            email: 'メールアドレス',
            group: '役割',
            managedBy: '管理者',
            area: 'リージョン',
            office: '営業所'
          },
          buttons: {
            create: '新規登録',
            upload: '一括登録・更新',
            download: '登録情報の取得'
          },
          dialogs: {
            create: {
              title: 'アカウント新規登録'
            },
            edit: {
              title: 'アカウント編集'
            },
            mutate: {
              buttons: {
                cancel: 'キャンセル',
                done: '登録'
              }
            },
            selectManager: {
              title: '利用者の管理者の選択'
            }
          },
          groups: {
            admin: 'システム管理者',
            highManager: '上位管理者',
            manager: '管理者',
            user: '利用者'
          }
        },
        mappings: {
          fields: {
            name: '店舗名',
            spin: '地点番号',
            code: '店番',
            managedBy: '担当者',
            'managedBy.name': '氏名',
            'managedBy.email': 'メールアドレス',
            'managedBy.helperText': 'クリックして選択',
            'managedBy.helperTextEdit': 'クリックして変更'
          },
          dialogs: {
            edit: {
              title: '店舗登録編集'
            },
            mutate: {
              buttons: {
                cancel: 'キャンセル',
                done: '登録'
              }
            },
            selectAccount: {
              title: '担当者の選択',
              buttons: {
                cancel: 'キャンセル'
              }
            }
          },
          download: {
            dialog: {
              content:
                '登録済の店舗の一覧をダウンロードします。\n\nダウンロードしたファイルを編集し、一括更新が可能です。',
              buttons: {
                cancel: 'キャンセル',
                confirm: 'ダウンロード'
              }
            },
            notification: {
              downloading: 'ダウンロード中...',
              downloadError: 'ダウンロードできません。',
              noAccounts: '担当者に設定できるアカウントが登録されていません。'
            }
          },
          upload: {
            dialog: {
              content:
                '必ず取得した登録済みの店舗の一覧のファイルを編集した\nファイルのアップロードを行ってください。\n\n',
              buttons: {
                cancel: 'キャンセル',
                confirm: 'アップロード'
              }
            }
          }
        },
        spots: {
          tabs: {
            daily: '日単位',
            monthly: '月単位',
            yearly: '年単位'
          },
          daily: {
            compareTo: {
              lastWeek: '前週同曜日',
              lastYearWithMonthlyAverage: '前年同月平均',
              lastYearWithYearlyAverage: '前年年間平均'
            }
          },
          monthly: {
            compareTo: {
              lastYear: '前年同月',
              lastMonth: '前月',
              lastYearWithMonthlyAverage: '前年同月平均'
            }
          },
          yearly: {
            compareTo: {
              lastYear: '前年度'
            }
          },
          fields: {
            date: '対象日'
          }
        },
        spotData: {
          fields: {
            base: 'ファイル名',
            threshold: '前日比較差の閾値'
          },
          buttons: {
            pdf: 'PDFダウンロード',
            data: 'データダウンロード'
          },
          caution:
            '＜注意＞\n既にデフォルト値として以下の内容が入力されております。\n※デフォルト値から変更してダウンロードされる場合は、ダウンロードに一定の時間を要します。\n【時間単位/日】\n比較元：前週（前週の日～土曜日）　比較対象：前週比　比較差の閾値：1.5\n※比較差の閾値に1.5を入力すると比較対象から150%以上の電気使用量になった時間帯を色付けいたします。\n【日単位/月】\n比較元：出力する日が属する月　比較対象：前年比　目標値の設定値：97.7％\n【月単位/年】\n出力する日の属する年度　比較対象：前年度'
        },
        spotData2: {
          selected: '選択した店舗',
          fields: {
            base: 'ファイル名',
            daily: {
              title: '時間単位/日',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '比較差の閾値'
            },
            monthly: {
              title: '日単位/月',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '目標値の設定値(%)'
            },
            yearly: {
              title: '月単位/年',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '比較差の閾値'
            }
          }
        },
        spotSelect: {
          dialog: {
            title: '店舗の選択'
          },
          buttons: {
            trigger: '店舗の選択',
            all: 'すべて選択',
            clear: '選択解除',
            close: '閉じる'
          }
        },
        spotList: {
          buttons: {
            all: 'すべて選択',
            clear: '選択解除'
          }
        },
        compare: {
          selected: '選択した店舗',
          buttons: {
            target: '対象月',
            input: '対象データの設定',
            close: '閉じる',
            set: '設定',
            execute: '実行',
            compare: '比較グラフ表示'
          },
          show: {
            0: '比較元',
            1: '比較先'
          },
          fileSelect: 'ファイルを選択してください',
          fields: {
            sourceKey: {
              label: '集計に使用する項目名',
              helperText:
                '比較用データとして設定するデータが何のデータか入力ください。\n（例：売上、来店数、延床面積など）'
            },
            targetKey: {
              label: '照合する項目名',
              helperText:
                '電力量のデータにおいて、照合に使用する各店舗の項目の名称を選択してください'
            },
            dateKey: {
              label: '照合する月の形式',
              helperText:
                '指定されたCSVファイルにおいて、照合に使用する月の項目の表示形式を選択してください'
            },
            categories: {
              label: 'グラフの分類項目の設定',
              labels: {
                '0': '左下のエリア',
                '1': '右下のエリア',
                '2': '左上のエリア',
                '3': '右上のエリア'
              }
            }
          }
        },
        allData: {
          fields: {
            all: 'すべての店舗'
          },
          buttons: {
            download: 'データダウンロード',
            clear: '対象店舗の選択解除'
          }
        },
        announce: {
          title: 'サービスからのお知らせ'
        },
        summarys: {
          fields: {
            name: '店舗',
            daily: '時間単位/日',
            monthly: '日単位/月',
            yearly: '月単位/年',
            'daily.date': '比較元',
            'daily.compareTo': '比較対象',
            'monthly.date': '比較元',
            'monthly.compareTo': '比較対象',
            'yearly.date': '比較元',
            'yearly.compareTo': '比較対象'
          }
        },
        mergedUsers: {
          fields: {
            name: '店舗名',
            spin: '供給/受電地点特定番号',
            kind: '契約種別',
            address: '住所'
          }
        },
        footer: {
          text: '© Chubu Electric Power Miraiz Connect, Inc. All rights reserved'
        }
      }
    },
    'e1a275a2-83c6-415f-b077-2f8ac1e00aa3': {
      resources: {
        dashboard: {
          title: 'テラシテSサービス管理ページ',
          menu: {
            admin: {
              accounts: 'アカウント管理',
              mappings: '店舗管理'
            },
            highManager: {
              cognitoLog: 'ログインログ取得'
            },
            spot: '店舗単位表示',
            compare: '店舗間比較表示',
            spotData: '店舗データ出力',
            summary: '分析データ出力'
          },
          notification: {
            cannotUse: 'ご利用できません'
          }
        },
        accounts: {
          fields: {
            name: '氏名',
            email: 'メールアドレス',
            group: '役割',
            managedBy: '管理者',
            area: 'リージョン',
            office: '営業所'
          },
          buttons: {
            create: '新規登録',
            upload: '一括登録・更新',
            download: '登録情報の取得'
          },
          dialogs: {
            create: {
              title: 'アカウント新規登録'
            },
            edit: {
              title: 'アカウント編集'
            },
            mutate: {
              buttons: {
                cancel: 'キャンセル',
                done: '登録'
              }
            },
            selectManager: {
              title: '利用者の管理者の選択'
            }
          },
          groups: {
            admin: 'システム管理者',
            highManager: '上位管理者',
            manager: '管理者',
            user: '利用者'
          }
        },
        mappings: {
          fields: {
            name: '店舗名',
            spin: '地点番号',
            code: '店番',
            managedBy: '担当者',
            'managedBy.name': '氏名',
            'managedBy.email': 'メールアドレス',
            'managedBy.helperText': 'クリックして選択',
            'managedBy.helperTextEdit': 'クリックして変更',
            ownedBy: 'オーナー',
            'ownedBy.name': '氏名',
            'ownedBy.email': 'メールアドレス',
            'ownedBy.helperText': 'クリックして選択',
            'ownedBy.helperTextEdit': 'クリックして変更'
          },
          dialogs: {
            edit: {
              title: '店舗登録編集'
            },
            mutate: {
              buttons: {
                cancel: 'キャンセル',
                done: '登録'
              }
            },
            selectAccount: {
              title: '担当者の選択',
              buttons: {
                cancel: 'キャンセル',
                clear: '削除'
              }
            },
            selectOwnerAccount: {
              title: 'オーナーの選択'
            }
          },
          download: {
            dialog: {
              content:
                '登録済の店舗の一覧をダウンロードします。\n\nダウンロードしたファイルを編集し、一括更新が可能です。',
              buttons: {
                cancel: 'キャンセル',
                confirm: 'ダウンロード'
              }
            },
            notification: {
              downloading: 'ダウンロード中...',
              downloadError: 'ダウンロードできません。',
              noAccounts: '担当者に設定できるアカウントが登録されていません。'
            }
          },
          upload: {
            dialog: {
              content:
                '必ず取得した登録済みの店舗の一覧のファイルを編集した\nファイルのアップロードを行ってください。\n\n',
              buttons: {
                cancel: 'キャンセル',
                confirm: 'アップロード'
              }
            }
          }
        },
        spots: {
          tabs: {
            daily: '日単位',
            monthly: '月単位',
            yearly: '年単位'
          },
          daily: {
            compareTo: {
              lastWeek: '前週同曜日',
              lastYearWithMonthlyAverage: '前年同月平均',
              lastYearWithYearlyAverage: '前年年間平均'
            }
          },
          monthly: {
            compareTo: {
              lastYear: '前年同月',
              lastMonth: '前月',
              lastYearWithMonthlyAverage: '前年同月平均'
            }
          },
          yearly: {
            compareTo: {
              lastYear: '前年度'
            }
          },
          fields: {
            date: '対象日'
          }
        },
        spotData: {
          fields: {
            base: 'ファイル名',
            threshold: '前日比較差の閾値'
          },
          buttons: {
            pdf: 'PDFダウンロード',
            data: 'データダウンロード'
          },
          caution:
            '＜注意＞\n既にデフォルト値として以下の内容が入力されております。\n※デフォルト値から変更してダウンロードされる場合は、ダウンロードに一定の時間を要します。\n【時間単位/日】\n比較元：前週（前週の日～土曜日）　比較対象：前週比　比較差の閾値：1.5\n※比較差の閾値に1.5を入力すると比較対象から150%以上の電気使用量になった時間帯を色付けいたします。\n【日単位/月】\n比較元：出力する日が属する月　比較対象：前年比　目標値の設定値：97.7％\n【月単位/年】\n出力する日の属する年度　比較対象：前年度'
        },
        spotData2: {
          selected: '選択した店舗',
          fields: {
            base: 'ファイル名',
            daily: {
              title: '時間単位/日',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '比較差の閾値'
            },
            monthly: {
              title: '日単位/月',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '目標値の設定値(%)'
            },
            yearly: {
              title: '月単位/年',
              date: '比較元',
              compareTo: '比較対象',
              threshold: '比較差の閾値'
            }
          }
        },
        spotSelect: {
          dialog: {
            title: '店舗の選択'
          },
          buttons: {
            trigger: '店舗の選択',
            all: 'すべて選択',
            clear: '選択解除',
            close: '閉じる'
          }
        },
        spotList: {
          buttons: {
            all: 'すべて選択',
            clear: '選択解除'
          }
        },
        compare: {
          selected: '選択した店舗',
          buttons: {
            target: '対象月',
            input: '対象データの設定',
            close: '閉じる',
            set: '設定',
            execute: '実行',
            compare: '比較グラフ表示'
          },
          show: {
            0: '比較元',
            1: '比較先'
          },
          fileSelect: 'ファイルを選択してください',
          fields: {
            sourceKey: {
              label: '集計に使用する項目名',
              helperText:
                '比較用データとして設定するデータが何のデータか入力ください。\n（例：売上、来店数、延床面積など）'
            },
            targetKey: {
              label: '照合する項目名',
              helperText:
                '電力量のデータにおいて、照合に使用する各店舗の項目の名称を選択してください'
            },
            dateKey: {
              label: '照合する月の形式',
              helperText:
                '指定されたCSVファイルにおいて、照合に使用する月の項目の表示形式を選択してください'
            },
            categories: {
              label: 'グラフの分類項目の設定',
              labels: {
                '0': '左下のエリア',
                '1': '右下のエリア',
                '2': '左上のエリア',
                '3': '右上のエリア'
              }
            }
          }
        },
        allData: {
          fields: {
            all: 'すべての店舗'
          },
          buttons: {
            download: 'データダウンロード',
            clear: '対象店舗の選択解除'
          }
        },
        announce: {
          title: 'サービスからのお知らせ'
        },
        summarys: {
          fields: {
            name: '店舗',
            daily: '時間単位/日',
            monthly: '日単位/月',
            yearly: '月単位/年',
            'daily.date': '比較元',
            'daily.compareTo': '比較対象',
            'monthly.date': '比較元',
            'monthly.compareTo': '比較対象',
            'yearly.date': '比較元',
            'yearly.compareTo': '比較対象'
          }
        },
        mergedUsers: {
          fields: {
            name: '店舗名',
            spin: '供給/受電地点特定番号',
            kind: '契約種別',
            address: '住所'
          }
        },
        footer: {
          text: '© Chubu Electric Power Miraiz Connect, Inc. All rights reserved'
        }
      }
    }
  },
  int: {},
  dev: {},
  exp: {}
}
